<template>
  <div class="cart-icon">
    <div
      class="shopping-cart-button float-right"
      @click="redirectToCarts()">
      <i class="fa fa-shopping-cart"/>
      <span class="text">{{ totalItem }}</span>
    </div>
    <div class="shopping-cart-dropdown-pane">
      <div
        class="dropdown-pane bottom "
        data-dropdown
        data-hover="true"
        data-hover-pane="true">
        <perfect-scrollbar>
          <div 
            v-if="carts && carts.length > 0" 
            class="item-cart">
            <div
              v-for="cart in carts"
              class="shopping-cart-item">
              <card-item
                :vatpham="cart"
                @deleteCart="deleteCart($event)"
                @updateCount="updateCount($event)"/>
            </div>
          </div>
        </perfect-scrollbar>
        <div class="btn-checkout">
          <button 
            class="btn btn-order btn-pri"
            @click="redirectToCarts">Xem giỏ hàng</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatMoney from "../../utils/StringUtils";
  import CardItem from "./CardItem";

  export default {
    name: "CartIcon",
    components: {
      CardItem
    },
    data() {
      return {
        carts: [],
        amount: 0,
        totalItem: 0,
      }
    },
    mounted() {
      this.loadCarts();

      this.$store.watch(
        (state, getters) => getters.getCartUpdate,
        (newValue, oldValue) => {
          this.loadCarts();
        },
      );
    },
    methods: {
      loadCarts() {
        const cartsListStorage = localStorage.getItem('carts');
        this.carts = cartsListStorage ? JSON.parse(cartsListStorage) : [];
        this.calculateMoney();
      },
      calculateMoney() {
        this.amount = 0;
        this.totalItem = 0;
        if (this.carts && this.carts.length > 0) {
          const totalAmount = this.carts.reduce((amount, item) => {
            this.totalItem += item.count;
            return amount + parseInt(item.price_sale && (item.price_sale + "").replace(new RegExp(',', 'g'), ''))*item.count
          }, 0);
          this.amount = formatMoney(totalAmount, 0);
        }
      },
      redirectToCarts() {
        this.$router.push("cart");
      },
      updateCount(vatpham) {
        for (const cart of this.carts) {
          if (cart.id === vatpham.id) {
            cart.count = vatpham.count;
          }
        }
        localStorage.setItem('carts', JSON.stringify(this.carts));
        this.$store.dispatch('updateCart');
        this.calculateMoney();
      },
      deleteCart(vatpham){
        this.carts = this.carts.filter(obj => obj.id !== vatpham.id);
        localStorage.setItem('carts', JSON.stringify(this.carts));
        this.$store.dispatch('updateCart');
        this.calculateMoney();
      },
    },
  }
</script>

<style lang="scss" scoped>
  /*.cart-icon:hover {*/
  /*  .shopping-cart-dropdown-pane {*/
  /*    transform: scale(1);*/
  /*  }*/
  /*}*/

  .cart-icon {
    position: relative;
    padding: 8px;

    .shopping-cart-button {
      background-color: transparent;
      position: relative;
      cursor: pointer;
      &:hover {
        background-color: transparent;
      }
      i {
        margin-right: 0.5rem;
        color: white;
        font-size: 18px;
      }
      span {
        position: absolute;
        top: -5px;
        right: -5px;
        background: white;
        border-radius: 50%;
        padding: 0px 4px;
        border: 1px solid #418AEB;
        color: #418AEB;
        font-weight: bold;
      }
    }

    .shopping-cart-dropdown-pane {
      z-index: 1000;
      width: 300px;
      right: 0;
      top: 40px;
      position: absolute;
      transition: 0.5s all;
      transform: scale(0) ;
      transform-origin: 100% 0%;
      .dropdown-pane {
        position: relative;
        background: white;
        border-radius: .4em;
        padding: 8px;

        .ps {
          height: 350px;
          margin-bottom: 40px;
        }

        .btn-checkout {
          width: 100%;
          background: white;
          position: fixed;
          bottom: 0;
          right: 0;
          padding: 8px;
          button {
            width: 100%;
          }
        }
      }
      .dropdown-pane:after {
        content: '';
        position: absolute;
        top: 0;
        right: 6px;
        width: 0;
        height: 0;
        border: 12px solid transparent;
        border-bottom-color: white;
        border-top: 0;
        margin-left: -12px;
        margin-top: -12px;
      }
    }

    .shopping-cart-item {
      display: flex;
      justify-content: space-between;
    }

    .shopping-cart-item-name, .shopping-cart-item-price {
      padding: 0 1rem;

      p {
        margin: 0;
        padding: 0;
      }
    }

    .shopping-cart-title {
      font-weight: bold;
    }

    .shopping-cart-checkout {
      padding: 0.5rem;
      margin-bottom: 0;
    }
  }
  .btn-pri {
    background: #4189EB;
    color: #fff;
    border-radius: 45px;
  }
  @media (max-width: 767px) {
    .shopping-cart-button {
      i {
        color: #418AEB !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cart/CartIcon.vue